import React, {Component} from 'react';
import './Review.css';
import {Avatar} from '../widgets';
import {Link} from 'react-router-dom';

class Review extends Component {
	render() {
		const {
			review: {
				rating,
				communication,
				quality,
				affordability,
				trust,
				content,
				reviewer: {
					user: {firstname, lastname}
				}
			}
		} = this.props;

		return (
			<li className={`Review ${content && content.length ? '' : 'notext'}`}>
				<div className="Review-contents">
					{!!content && !!content.trim().length && <div className="Review-text">{content}</div>}
					{rating && (
						<div className="Review-rating">
							{[true, true, true, true, true].map((val, idx) => (
								<span key={idx} className={idx < rating ? 'icon-star' : 'icon-star_border'} />
							))}
						</div>
					)}
					{hasSpark(this.props.review) && (
						<ol className="Review-spark">
							<li>
								<label>C</label>
								<gutter>
									<value style={{width: communication ? '100%' : '0%'}} />
								</gutter>
							</li>
							<li>
								<label>Q</label>
								<gutter>
									<value style={{width: quality ? '100%' : '0%'}} />
								</gutter>
							</li>
							<li>
								<label>A</label>
								<gutter>
									<value style={{width: affordability ? '100%' : '0%'}} />
								</gutter>
							</li>
							<li>
								<label>T</label>
								<gutter>
									<value style={{width: trust ? '100%' : '0%'}} />
								</gutter>
							</li>
						</ol>
					)}
				</div>
				<div className="Review-attribution">
					<Avatar provider={this.props.review.reviewer} />
					<Link
						title={this.props.review.reviewer.firstname}
						to={`/@${this.props.review.reviewer.profile.uniqueName}`}>
						<div className="Review-name">
							{firstname} {lastname}
						</div>
					</Link>
				</div>
			</li>
		);
	}
}

const hasSpark = review =>
	hasVal(review.communication) ||
	hasVal(review.quality) ||
	hasVal(review.affordability) ||
	hasVal(review.trust);

const hasVal = val => !!(val || val === 0);

export default Review;



// WEBPACK FOOTER //
// ./src/profile/Review.js